import "../assets/css/benefits.css";
import config from "../config/memberhubContents.json";
import { useSelector } from 'react-redux';
import PhoneNumber from "./phoneNumber";
import TermsAndConditions from "./termsAndConditions";
import SuccessIcon from "./successIcon";

function CodeRewardFlow(props) {
    const redeemedReward = useSelector(state => state.data.redeemedReward);
    const redeemedRewardLoading = useSelector(state => state.data.redeemRewardLoading)
    const redeemedRewardError = useSelector(state => state.data.redeemedRewardError)
    const codeAccessed = data => data.reference_id === "code_code" && data.redeemed && data.redeemed.codes;
    const isSoldOut = data => data.reference_id === "code_code" && !data.redeemed && data.extra_data && data.extra_data.sold_out === "1" && data.max_select_quantity === 0;

    return (
        <>
            {/* Page 1 description */}
            {!props.getCodeClicked &&
                <div dangerouslySetInnerHTML={{ __html: props.descriptionSection1 }}></div>
            }
            {/* Description 2 for sold out benefits */}
            {!props.getCodeClicked && props.descriptionSection2 && isSoldOut(props.reward) &&
                <div className="modal-description2" dangerouslySetInnerHTML={{ __html: props.descriptionSection2 }}></div>
            }
            {/* Page 1 description to remain until redemption API returns response */}
            {props.getCodeClicked && (redeemedRewardLoading || (redeemedRewardError && Object.keys(redeemedRewardError).length > 0)) &&
                <div dangerouslySetInnerHTML={{ __html: props.descriptionSection1 }}></div>
            }
            {/* Congrats message after code redemption */}
            {props.getCodeClicked && props.reward.reference_id !== "sweepstakes" && redeemedReward && Object.keys(redeemedReward).length > 0 && redeemedReward.status === "success" && !redeemedRewardLoading && (!redeemedRewardError || Object.keys(redeemedRewardError).length === 0) && redeemedReward.data && redeemedReward.data.codes && redeemedReward.data.codes.length > 0 && redeemedReward.data.codes[0] &&
                <div className="modal-congrats">
                    {props.reward.reference_id === "code_code" ? config.codeCongratsMessage : config.urlCongratsMessage}
                </div>
            }
            {props.getCodeClicked && props.reward.reference_id === "sweepstakes" && redeemedReward && Object.keys(redeemedReward).length > 0 && redeemedReward.status === "success" && !redeemedRewardLoading && (!redeemedRewardError || Object.keys(redeemedRewardError).length === 0) &&
                <>
                    <SuccessIcon />
                    <div className="modal-congrats-sweepstakes">
                        {config.sweepstakesCongratsMessage}
                    </div>
                </>
            }
            {(props.reward.reference_id === "code_code") &&
                <div className="modal-code-container">
                    {/* Warning section for code_code reward */}
                    {!props.getCodeClicked && (props.reward.max_select_quantity === 0 || codeAccessed(props.reward)) && !isSoldOut(props.reward) &&
                        <>
                            <p className="modal-last-code">
                                Last issued code
                            </p>
                            <div className="modal-code">
                                {props.reward.redeemed.codes[0].code}
                            </div>
                        </>
                    }
                    {/* code section in Page 2 of code_code reward  */}
                    {props.getCodeClicked && props.reward.reference_id !== "sweepstakes" && redeemedReward && Object.keys(redeemedReward).length > 0 && redeemedReward.status === "success" && !redeemedRewardLoading && (!redeemedRewardError || Object.keys(redeemedRewardError).length === 0) && redeemedReward.data && redeemedReward.data.codes && redeemedReward.data.codes.length > 0 && redeemedReward.data.codes[0] &&
                        <div className="modal-code">
                            {redeemedReward.data.codes[0]}
                        </div>
                    }
                </div>
            }

            {/* Warning message for both code_code and code_url reward and sweepstakes */}
            {props.reward.reference_id !== "sweepstakes" && props.reward.max_select_quantity === 0 && !isSoldOut(props.reward) ?
                <div className="modal-error-row">
                    <div className="modal-error-icon">
                        <svg
                            width={24}
                            height={25}
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M12 20.5C16.4183 20.5 20 16.9183 20 12.5C20 8.08172 16.4183 4.5 12 4.5C7.58172 4.5 4 8.08172 4 12.5C4 16.9183 7.58172 20.5 12 20.5ZM12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z"
                                fill="#4E5356"
                            />
                            <path
                                d="M12.9949 17.5H10.9929V10.2371H12.9949V17.5ZM10.9999 7.5149C10.9999 7.23035 11.0821 6.99006 11.2465 6.79404C11.417 6.59801 11.6666 6.5 11.9954 6.5C12.3241 6.5 12.5738 6.59801 12.7442 6.79404C12.9147 6.99006 12.9999 7.23035 12.9999 7.5149C12.9999 7.79946 12.9147 8.03659 12.7442 8.22629C12.5738 8.41599 12.3241 8.51084 11.9954 8.51084C11.6666 8.51084 11.417 8.41599 11.2465 8.22629C11.0821 8.03659 10.9999 7.79946 10.9999 7.5149Z"
                                fill="#4E5356"
                            />
                        </svg>
                    </div>
                    <div className="modal-error-message">
                        {props.reward.reference_id === "code_code" && config.codeRewardErrorMessage}
                        {props.reward.reference_id === "code_url" && config.urlRewardErrorMessage}
                    </div>
                </div>
                :
                <>
                    {/* Display section 2 of description if exists */}
                    {props.getCodeClicked && props.descriptionSection2 && !redeemedRewardLoading && (!redeemedRewardError || Object.keys(redeemedRewardError).length === 0) &&
                        <div className="modal-description2" dangerouslySetInnerHTML={{ __html: props.descriptionSection2 }}></div>
                    }
                </>
            }
            {/* Warning message for sweepstakes if the reward is already redeemed */}
            {props.reward.reference_id === "sweepstakes" && !props.getCodeClicked && props.reward.max_select_quantity === 0 &&
                <>
                    <br />
                    <SuccessIcon />
                    <div className="modal-warning-sweepstakes" dangerouslySetInnerHTML={{ __html: config.sweepstakesErrorMessage }}></div>
                </>
            }
            {/* Display phone number and T&C if it's value is true in API response */}
            {!props.getCodeClicked && props.reward.max_select_quantity !== 0 &&
                <>
                    {props.reward.is_phone_number_required === 1 &&
                        <PhoneNumber getCodeClicked={props.getCodeClicked} />
                    }
                    {props.reward.reward_terms &&
                        <TermsAndConditions reward={props.reward} />
                    }
                </>
            }
        </>
    );
}

export default CodeRewardFlow;
